import { cn } from "@/lib/utils";
import { ImageBody, useWishlistImage } from "../api";
import { Check, Loader2 } from "lucide-react";
import { useEffect, useState } from "react";
import { Button } from "@/shared/ui/button.tsx";
import { useAtomValue } from "jotai";
import { themeAtom } from "@/features/app-layout/atoms/theme-atoms";
import HeartLogo from "@/assets/heart.svg?react"
import HeartFillLogo from "@/assets/heart-filled.svg?react"

type Props = {
  isSelected: boolean,
  image: ImageBody,
  onSelect: (image: {image_id: number, image_url: string, type: string}) => void
}

const ImageSelection = ({ isSelected, image, onSelect }: Props) => {

  const [loading, setLoading] = useState(true)

  const [isWishlist, setIsWishlist] = useState(image.wishlist)

  useEffect(() => {
    setLoading(true)
    setIsWishlist(image.wishlist)
  }, [image])


  const { wishlistImage } = useWishlistImage()


  const handleExpandClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    // setCurrentImage({ id: image.id, url: image.image_url })
    // setOpenPreview(true)
  }

  const theme = useAtomValue(themeAtom)

  return (
    <div
      className={cn(
        "relative aspect-square overflow-hidden bg-white rounded-xl cursor-pointer transition-all",
        "border",
        isSelected
          ? "border-primary ring-2 ring-primary ring-offset-2 ring-offset-background"
          : "border-gray-800 hover:border-gray-600",
      )}
      onClick={handleExpandClick}
    >
      {loading && image.catalogue_item !== "video" &&
        <div className="absolute inset-0 z-30  flex items-center justify-center">
          <Loader2 className="animate-spin" />
        </div>
      }
      {image.catalogue_item === "video"
        ? <video 
        src={image.image_url || "/placeholder.svg"}
        className={cn("object-cover transition-all hover:scale-110 duration-700 w-full aspect-square", isSelected ? "opacity-90" : "opacity-100")}
          autoPlay muted playsInline loop
        />
        :<img
        src={image.image_url || "/placeholder.svg"}
        alt={image.prompt}
        className={cn("object-cover transition-all hover:scale-110 duration-700 w-full aspect-square", isSelected ? "opacity-90" : "opacity-100")}
        onLoad={() => setLoading(false)}
      /> }

      <Button
        size="icon"
        style={{
          backgroundImage: isSelected ? `linear-gradient(45deg, ${theme.secondary}, ${theme.alternate})` : "linear-gradient(45deg, #fff, #fff)",
          backgroundSize: "200%"
        }}
        onClick={(e) => {
          e.stopPropagation()
          onSelect({image_id: image.id, image_url: image.image_url, type: image.catalogue_item})
        }}
        className="rounded-full bg-white animate-wave p-2 absolute top-2 right-2 z-50">
        <Check className="h-6 w-6 text-black" />
      </Button>
      <Button size="icon" className="rounded-full bg-white hover:text-white animate-wave p-2 absolute bottom-2 size-7 left-2 text-black z-50" onClick={(e) => {
        e.stopPropagation()
        setIsWishlist(prev => !prev)
        wishlistImage(image.id)
      }}>
        {isWishlist ?
          <HeartFillLogo className="text-red-400" fill="red" /> : <HeartLogo />
        }
      </Button>
    </div>
  )
}

export default ImageSelection;
